import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';

const AlertCircleIcon = ({ fill='#000', ...props }) => {
  return (
    <Icon viewBox="0 0 80 80" {...props}>
      <path
        fill={fill}
        d="M44.0524444,41.361 C43.7557778,43.271 41.9768889,44.9898889 40.098,44.9898889 L39.8024444,44.9898889 C38.0224444,44.9898889 36.2435556,43.271 35.9457778,41.361 C34.3646667,33.3387778 33.5735556,24.7443333 32.7824444,17.5832222 C32.6846667,15.9598889 34.068,14.1454444 35.8468889,13.7632222 C39.1102222,13.1898889 40.988,13.1898889 44.2502222,13.7632222 C46.1291111,14.1454444 47.3157778,15.9598889 47.2168889,17.5832222 C46.4257778,24.7443333 45.6346667,33.3387778 44.0524444,41.361 M40.0002222,66.6665556 C36.0446667,66.6665556 32.8813333,63.611 32.8813333,59.791 C32.8813333,55.971 36.0446667,52.9154444 40.0002222,52.9154444 C43.9535556,52.9154444 47.118,55.971 47.118,59.791 C47.118,63.611 43.9535556,66.6665556 40.0002222,66.6665556 M40.0002222,-0.000111111111 C17.9091111,-0.000111111111 0.000222222222,17.9087778 0.000222222222,39.9998889 C0.000222222222,62.091 17.9091111,79.9998889 40.0002222,79.9998889 C62.0913333,79.9998889 80.0002222,62.091 80.0002222,39.9998889 C80.0002222,17.9087778 62.0913333,-0.000111111111 40.0002222,-0.000111111111"
      />
    </Icon>
  );
};

AlertCircleIcon.propTypes = {
  fill: PropTypes.string,
};

export default AlertCircleIcon;
